































































import Vue from 'vue'
import { defineComponent, ref, watch, computed } from '@vue/composition-api'
import { NodeUmd } from '@/assets/node'
import { loadItemUmd } from '@/components/mobile-render/render/utils'
import { MessageBox, Message, Loading } from 'element-ui'
import { http } from '@/api'
import { tabCurrent, tabName } from '@/assets/tab'
import { project } from '@/assets/project'

const empty = {
  label: '',
  umdName: '',
  url: '',
  isReleaseDownload: false,
  type: 'js'
}

export default defineComponent({
  name: 'component-umd',
  props: {
    show: Boolean
  },
  setup (props, ctx) {
    const showDialog = ref(false)
    const list = ref([])
    const dialogForm = ref({})
    const selected = computed(() => project.componentUmd.map(x => x.label))
    const handleEdit = (item: NodeUmd) => {
      handleAddUmd(item)
    }
    const handleAddUmd = (item?: NodeUmd) => {
      if (item) {
        // @ts-ignore
        dialogForm.value = { type: 'js', ...item }
      } else {
        dialogForm.value = { ...empty }
      }
      showDialog.value = true
    }
    const handleDelete = async (item: NodeUmd, i: number) => {
      await MessageBox.confirm('确定要删除吗？')
      // 移除项目引用
      const index = selected.value.findIndex(x => x === item.label)
      project.componentUmd.splice(index, 1)
      // 移除库
      await http.post('component/umdSave', { ...item, delete: true }, { successMessage: '删除成功' })
      list.value.splice(i, 1)
    }
    const confirm = () => {
      // @ts-ignore
      ctx.refs.form.validate((valid: boolean) => {
        if (valid) {
          http.post('component/umdSave', {
            ...dialogForm.value,
            userName: Vue.prototype.$native.name
          }, { successMessage: '操作成功' }).then(() => {
            getList()
            showDialog.value = false
          })
        }
      })
    }
    const getList = () => {
      http.get('component/list', { type: 'umd' }).then(res => {
        list.value = res.data
      })
    }
    // const stop = watch(() => tabCurrent.tab2, cur => {
    //   if (cur === tabName.umdComponent) {
    //     getList()
    //     stop()
    //   }
    // })
    watch(() => props.show, val => {
      if (val) {
        getList()
      }
    })
    const handleAdd = async (item: NodeUmd) => {
      const loading = Loading.service({ text: '加载中...' })
      const i = selected.value.findIndex(x => x === item.label)
      if (!window.defineBak && window.define) {
        window.defineBak = window.define
      }
      window.define = null
      await loadItemUmd(item, i === -1).catch(err => {
        Message.error(err)
        loading.close()
        return Promise.reject(err)
      })
      loading.close()
      window.define = window.defineBak
      if (i > -1) {
        project.componentUmd.splice(i, 1)
        Message.success('取消成功')
      } else {
        project.componentUmd.push(item)
        Message.success('添加成功')
      }
      ctx.emit('hide')
    }
    return {
      showDialog,
      dialogForm,
      dialogFormRules: {
        label: [
          { required: true, message: '请输入', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        umdName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入', trigger: 'blur' },
          { min: 3, max: 500, message: '长度在 3 到 500 个字符', trigger: 'blur' }
        ]
      },
      list,
      selected,
      handleEdit,
      handleAddUmd,
      handleDelete,
      confirm,
      handleAdd
    }
  }
})
